import { IRouterMiddleware } from '../middleware.interface';
import { ClearOauthState } from './ClearOauthState';
import { HandleAuthCallback } from './HandleAuthCallback';
import { HandleOauthCallback } from './HandleOauthCallback';
import { HandleShouldHideRedirect } from './HandleShouldHideRedirect';
import { LoadBusinessList } from './LoadBusinessList';
import { LoadProvidersList } from './LoadProvidersList';
import { HandleInviteRedirect } from './InviteRedirect';
import { HandleAccessGuard } from './AccessGuard';
import { HandleBusinessOnboardingRedirect } from './BusinessOnboardingRedirect';
import { HandleSigninRedirectRestrictedPages } from './HandleSigninRedirectRestrictedPages';
import { HandleInviteMerchantRedirect } from './InviteMerchantRedirect';
import { HandleAISignupRedirect } from './AISignupRedirect';
import { HandleSellCoinsRedirect } from './SellCoinsRedirect';

export const middlewares: IRouterMiddleware[] = [
  new LoadBusinessList(),
  new LoadProvidersList(),
  new HandleOauthCallback(),
  new HandleSellCoinsRedirect(),
  new ClearOauthState(),
  new HandleAuthCallback(),
  new HandleShouldHideRedirect(),
  new HandleInviteRedirect(),
  new HandleSigninRedirectRestrictedPages(),
  new HandleAccessGuard(),
  new HandleBusinessOnboardingRedirect(),
  new HandleInviteMerchantRedirect(),
  new HandleAISignupRedirect()
];
